// Unpublished Work © 2020-2026 Deere & Company.

import {combineReducers} from 'redux';

import {userDataReducer} from './user-data';
import {getCustomerProfileCombinedReducer} from './customer-profile';
import {getCustomerSearchCombinedReducer} from './customer-search';
import {getDigitalUserSearchCombinedReducer} from './digital-user-search';
import {getAddCustomerCombinedReducer} from './add-customer';
import {getSelectBusinessContactReducer} from './select-business-contact';
import {getDbsCustomerProfileCombinedReducer} from './dbs-customer-profile';
import {configurationReducer} from './configuration';
import {customerIdsReducer} from './customer-ids';
import {selectedContextReducer} from './selected-context';
import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const rootPersistConfig = {
    key: 'root',
    storage,
    whitelist: ['customerIds', 'selectedContext']
};

export const allReducers = () => combineReducers({
    addCustomer: getAddCustomerCombinedReducer(),
    configuration: configurationReducer,
    customerIds: customerIdsReducer,
    customerProfile: getCustomerProfileCombinedReducer(),
    customerSearch: getCustomerSearchCombinedReducer(),
    dbsCustomerProfile: getDbsCustomerProfileCombinedReducer(),
    digitalUserSearch: getDigitalUserSearchCombinedReducer(),
    selectBusinessContact: getSelectBusinessContactReducer(),
    selectedContext: selectedContextReducer,
    user: userDataReducer
});

export function getCombinedReducer() {
    return persistReducer(rootPersistConfig, allReducers());
}
